export const getCenterCoordinates = () => {
  const center: any = {
    lat: 36.251635,
    lng: 139.144973
  }
  return center
}
export const getDefaultZoomLevel = () => {
  const zoom: number = 13
  return zoom
}
